import React from 'react';
import _ from "underscore";

import config from "../../config";
import axios from "axios";
import appErrorLogger from "../common/DataDogErrorLog";

class SearchMenu extends React.Component {
    constructor() {
        super();
        this.state = {
            trendingSearches: [],
            popularBags: []
        };
    }
    componentDidMount() {
        if(!this.props.isCheckoutPage){
            axios.get(`${config.host_rebag_api}/v6/meta/trending-searches/`)
                .then((response) => {
                    this.setState({
                        trendingSearches: response.data
                    })
                })
                .catch((errors) => appErrorLogger('Get Trending Searches', errors))
            axios.get(`${config.host_rebag_api}/v6/meta/popular-bags/`)
                .then((response) => {
                    this.setState({
                        popularBags: response.data
                    })
                })
                .catch((errors) => appErrorLogger('Get Popular Bags', errors))
        }
    }

    render(){
        const {mobile, top_promo_banner_not_visible} = this.props;
        let {trendingSearches, popularBags} = this.state;
        if (mobile) {
            trendingSearches = trendingSearches.slice(0, 4);
        }

        return (
            <div className={`search-menu ${top_promo_banner_not_visible ? '' : 'with-top-banner'}`}>
                <div className="search-menu__left">
                    <h4 className="search-menu__title search-menu__title--left">Trending Searches</h4>
                    <div className="search-menu__trending-list">
                        {_.map(trendingSearches, (trendingItem, idx) => {
                            return (
                                <a
                                    key={idx}
                                    href={`${config.host_rebag_shop}${trendingItem.search_url}`}
                                    className="search-menu__trending-item"
                                >
                                    {trendingItem.title}
                                </a>
                            )
                        })}
                    </div>
                </div>
                <div className="search-menu__right">
                    <h4 className="search-menu__title search-menu__title--right">Popular Bags</h4>
                    <div className="search-menu__recently-viewed-list">
                        {_.map(popularBags, (popularBag, idx) => {
                            return (
                                <a
                                    key={idx}
                                    href={popularBag.product_url}
                                    className="search-menu__recently-viewed-item"
                                >
                                    <div className="search-menu__recently-viewed-img">
                                        <img
                                            src={popularBag.image_url}
                                            alt={popularBag.title}
                                        />
                                        {popularBag.status === 'sold' &&
                                        <div className="corner-ribbon top-left">Sold</div>
                                        }
                                    </div>
                                    <div className="search-menu__recently-viewed-details">
                                        <div className="search-menu__recently-viewed-top">
                                            <span
                                                className="search-menu__recently-viewed-designer">{popularBag.designer}</span>
                                            <span
                                                className="search-menu__recently-viewed-title">{popularBag.title}</span>
                                        </div>
                                        <div className="search-menu__recently-viewed-bottom">
                                            <span
                                                className="search-menu__recently-viewed-price">${popularBag.price}</span>
                                            <div className="search-menu__recently-viewed-condition">
                                                <span
                                                    className="search-menu__recently-viewed-condition-label">Condition: </span>
                                                <span
                                                    className="search-menu__recently-viewed-condition-value">{popularBag.condition}</span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            )
                        })}
                    </div>
                    <a
                        href={`${config.host_rebag_shop}/collections/all-bags`}
                        className="search-menu__view-all-bags"
                    >
                        View all bags
                    </a>
                </div>
            </div>
        )
    }
}

export default SearchMenu;